import React from 'react'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
const CheckoutTotalCell = ({ itemin }) => {
    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-2'>
                <div className=''>Cart Subtotal </div>
                <div className=''><CurrencyRupeeIcon className='f14' />{itemin?.cartSubtotal}</div>
            </div>
            {itemin?.discount>0?<><div className='d-flex align-items-center justify-content-between mb-2 text-success'>
                <div className=''>Discount </div>
                <div className=''>- <CurrencyRupeeIcon className='f14' />{itemin?.discount}</div>
            </div></>:<></>}
            <div className='d-flex align-items-center justify-content-between mb-2 fw-bold'>
                <div className=''>Total </div>
                <div className=''><CurrencyRupeeIcon className='f14' />{itemin?.total}</div>
            </div>
            {itemin?.gst>0?<><div className='d-flex align-items-center justify-content-between mb-2'>
                <div className=''>GST <span className='f12'>(inc.)</span></div>
                <div className=''><CurrencyRupeeIcon className='f14' />{itemin?.gst}</div>
            </div></>:<></>}
            <div className='d-flex align-items-center justify-content-between f16 fw-bold mb-3'>
                <div className=''>Grand Total </div>
                <div className=''><CurrencyRupeeIcon className='f14' />{itemin?.grandTotal}</div>
            </div>
        </>
    )
}

export default CheckoutTotalCell